<template>
  <div class="upload-file">
    <el-upload
      :action="rest?uploadFileUrl_rest:uploadFileUrl"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      :headers="rest?headers_rest:headers"
      :data="{'suffixs':fileType.join('|')}"
      :disabled="disabled"
      class="upload-file-uploader"
      ref="upload"
    >
      <!-- 上传按钮 -->
      <el-button size="mini" type="primary">选取文件</el-button>
      <!-- 上传提示 -->
      <div class="el-upload__tip" slot="tip" v-if="customTip">
        <template>
          <span style="color: #f56c6c">{{ customTip }}</span>
        </template>
      </div>
      <div class="el-upload__tip" slot="tip" v-if="showTip && !customTip">
        请上传
        <template v-if="fileSize">
          大小不超过
          <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
        <template v-if="fileType">
          格式为
          <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
        </template>
        的文件
      </div>
    </el-upload>
    <!-- 文件列表 -->
    <transition-group
      class="upload-file-list el-upload-list el-upload-list--text"
      name="el-fade-in-linear"
      tag="ul"
    >
      <li
        :key="index"
        class="el-upload-list__item ele-upload-list__item-content"
        v-for="(file, index) in fileList"
      >
        <div
          v-if="file.fileUrl != null"
          style="width: 100%;display: flex;justify-content: space-between;"
        >
          <el-link :underline="false" target="_blank">
            <span class="el-icon-document" @click="downLoadFile1(file)">{{ file.fileName || file.fileNames }}</span>
          </el-link>
          <div class="ele-upload-list__item-content-action">
            <el-link :underline="false" @click="handleDelete(index)" type="danger">删除</el-link>
          </div>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  props: {
    // 值
    value: [String, Object, Array],
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 30
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "doc", "xls", "ppt", "txt", "pdf"]
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customTip: {
      type: String,
      default: ""
    },
    rest: {
      type: Boolean,
      default: false
    },
    isDownLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uploadFileUrl: process.env.VUE_APP_URL + "/goldenseed/application/uploadFile", // 上传的图片服务器地址
      uploadFileUrl_rest: process.env.VUE_APP_URL + "/goldenseed/application/uploadFile", // rest上传的图片服务器地址
      headers: {
        Authorization: "Bearer " + getToken(),

      },
      headers_rest: {},
      fileList: []
    };
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    // 列表
    list() {
      if (this.value) {
        return this.value;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.fileList = [];
        return [];
      }
    }
  },
  watch: {
    list: {
      handler(newValue) {
        this.fileList = newValue;
      },
      immediate: true
    }
  },
  methods: {
    downLoadFile1(row) {
      if (this.isDownLoad) {
        window.open(row.fileUrl);
      }else {
        //预览
      }
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some(type => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传${this.limit}个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log("upload",res.data)
      this.fileList.push({
        fileNames: res.data.name,
        filePath: res.data.url,
        fileUrl: res.data.url,
        url: res.data.url,
        name: res.data.name,
        id: res.data.id
      });
      this.$message.success("上传成功");
      this.$emit("update:value", this.fileList);
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
      this.$emit("update:value", this.fileList);
    },
    created() {
      this.fileList = this.list;
    }
  }
};
</script>

<style scoped>
.upload-file-uploader {
  margin-bottom: 5px;
}

.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
  width: 60%;
}

.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}

.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
